import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiService } from '@core/providers/http';
import { PostoDocumentoParams } from '@core/models';

@Injectable({
  providedIn: 'root',
})
export class DocumentPostoService {
  private readonly endpoint = '/api/Documento/Posto';
  
    constructor( private readonly apiService: ApiService, ) {}
    
    gerarDocumento(params: PostoDocumentoParams,): Observable<Blob> {
      const httpParams = this.criarParametros(params);
      return this.apiService.get<Blob>(
        this.endpoint,
        httpParams,
        {
          responseType: 'blob',
        },
      );
    }
  
    private criarParametros(params: PostoDocumentoParams,): HttpParams {
      let httpParams = new HttpParams(); 

        if(params.DataInicioDe){
          httpParams = httpParams.set('DataInicioDe', params.DataInicioDe,);
        }
  
        if(params.DataInicioAte){
          httpParams = httpParams.set('DataInicioAte', params.DataInicioAte,);
        }
  
        if(params.ClienteId){
          httpParams = httpParams.set('ClienteId', String(params.ClienteId),);
        }
  
        if(params.PostoId){
          httpParams = httpParams.set('PostoId', String(params.PostoId),);
        }
  
        if(params.TipoPostoId){
          httpParams = httpParams.set('TipoPostoId', String(params.TipoPostoId),);
        }
  
        if(params.ProvinciaId){
          httpParams = httpParams.set('ProvinciaId', String(params.ProvinciaId),);
        }
  
        if(params.MunicipioId){
          httpParams = httpParams.set('Criticidade', String(params.MunicipioId),);
        }
  
        if(params.IsActive){
          httpParams = httpParams.set('TipoOcorrencia', String(params.IsActive),);
        }
  
        if(params.formatoDocumento){
          httpParams = httpParams.set('formatoDocumento', String(params.formatoDocumento),);
        }
  
      return httpParams;
      }
  
  
      criarUrlDownload( params: PostoDocumentoParams, baseUrl: string, ): string {
        const httpParams = this.criarParametros(params);
        return `${baseUrl}${this.endpoint}?${httpParams.toString()}`;
      }
}
  